<script>
export default {
	lang: 'shop',
	props: {
		order: Object,
	},
	computed: {
		expreso() {
			return this.order.deliveries?.[0].data?._expreso || {}
		},
	},
}
</script>
<template>
	<div>
		<div style="border: 1px solid #bbb" class="pa-4 rounded-lg py-2">
			<div>{{ expreso.name }}</div>
		</div>
	</div>
</template>

